import {connect} from "react-redux";
import CustomersPage from "./CustomersPage";
import * as AccountApiActions from "../actions/AccountApiActions";
import {requestInviteCustomer} from "../actions/OnboardingApiActions";
import * as ViewActions from "../actions/ViewActions";
import {withRouter} from "react-router";

export default connect(null, {...ViewActions, ...AccountApiActions, requestInviteCustomer})(withRouter(CustomersPage));